import TitleNews from './component'

export default TitleNews
